import React, { useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import { Button } from '@mui/material';

import { changesExist } from '@paragon/layout-models';

import { saveChanges } from '../../store/actions/projects';
import { useAppDispatch, useAppSelector } from '../hooks';

/** Saves pending changes across all projects. */
export function SaveProjectButton() {
  const dispatch = useAppDispatch();
  const projectChangesExist = useAppSelector(changesExist);
  const [isSaving, setIsSaving] = useState(false);

  return (
    <Button
      variant="contained"
      startIcon={<SaveIcon />}
      disabled={!projectChangesExist || isSaving}
      onClick={() => {
        setIsSaving(true);
        dispatch(saveChanges()).finally(() => setIsSaving(false));
      }}
    >
      Save Changes
    </Button>
  );
}
